import { of } from "rxjs";
import { delay, retryWhen, switchMap } from "rxjs/operators";
export function requestWithRetry(request) {
  var retryCount = 0;
  return request.pipe(retryWhen(function (notifier) {
    return notifier.pipe(switchMap(function (error) {
      console.error(error);
      retryCount++;
      if (retryCount < 10) {
        return of(0).pipe(delay(retryCount * 1000));
      }
      return of(0).pipe(delay(10000));
    }));
  }));
}